import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import EditMPCheckoutConfigContext from 'contexts/EditMPCheckoutConfigContext';
import MPCheckoutConfigForm from 'forms/MPCheckoutConfigForm';

export default (): JSX.Element => {
  const history = useHistory();
  const { t } = useTranslation();
  const { selectedMPCheckoutConfig } = React.useContext(EditMPCheckoutConfigContext);
  if (!selectedMPCheckoutConfig) {
    history.push('/private/admin/payments/mercado-pago-checkout');
    return <></>;
  }

  return (
    <div>
      <MPCheckoutConfigForm config={selectedMPCheckoutConfig} />
      <Box display="flex" justifyContent="center" width={1}>
        <Button className="btn-50" variant="contained" color="secondary" onClick={() => history.go(-1)}>
          {t('go-back')}
        </Button>
      </Box>
    </div>
  );
};
